import React from "react";

// Seamless editorial marquee. Duplicates content once for a -50% loop.
export const Marquee = ({ items, separator = "—", className = "" }) => {
  const content = (
    <>
      {items.map((t, i) => (
        <span key={i} className="inline-flex items-center">
          <span className="mx-6">{t}</span>
          <span className="text-primary/40">{separator}</span>
        </span>
      ))}
    </>
  );
  return (
    <div className={`marquee-mask overflow-hidden ${className}`} data-testid="marquee" aria-hidden="true">
      <div className="marquee-track">
        {content}
        {content}
      </div>
    </div>
  );
};
